export enum LayoutType {
  Centered = 'centered',
  Split = 'split',
  Grid = 'grid',
  FullWidth = 'fullwidth',
  MegaMenu = 'megamenu',
  ProductGrid = 'product-grid',
  ProductDetail = 'product-detail',
  Bento = 'bento',
  Marquee = 'marquee',
  Timeline = 'timeline',
  Accordion = 'accordion',
  Stats = 'stats'
}

export type DesignMindLanguage = 'en' | 'fr' | 'es' | 'de' | 'ar';

export interface Rationale {
  seo: string;
  aeo: string;
  ux: string;
  business: string;
  technical: string;
}

export interface MockupSection {
  id: string;
  type: 'header' | 'hero' | 'features' | 'testimonials' | 'pricing' | 'footer' | 'cta' | 'trust' | 'product-grid' | 'product-detail' | 'faq' | 'cart' | 'stats' | 'steps' | 'timeline';
  layoutType: string;
  headline: string;
  subheadline?: string;
  content?: string[];
  ctaText?: string;
  secondaryCtaText?: string;
  visualCue: string;
  rationale: Rationale;
  price?: string;
}

export interface MockupPage {
  id: string;
  name: string;
  route: string;
  description: string;
  metaTitle?: string;
  metaDescription?: string;
  sections: MockupSection[];
}

export interface GeneratedMockup {
  siteTitle: string;
  colorPaletteDescription: string;
  typographyDescription: string;
  pages: MockupPage[];
  overallStrategy: string;
}

export interface DesignMindUserInput {
  industry: string;
  businessModel: string;
  targetAudience: string;
  goals: string;
  cms: string;
  competitors: string;
  language: DesignMindLanguage;
}

export enum DesignMindAppState {
  Input,
  Generating,
  Result,
  Error
}

